import { SysProduct, User } from '../models/user';

export const getSysProducts = (currentUser: User | undefined): SysProduct[] => {
  return currentUser && currentUser.sysProducts ? [...currentUser.sysProducts] : [];
};
